<template>
    <div class="chart-portlet kt-portlet kt-portlet--fit kt-portlet--head-noborder" :id="portletId">
        <div class="kt-portlet__head kt-portlet__space-x">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">{{ title }}</h3>
            </div>
            <div class="kt-portlet__head-toolbar" v-if="link">
                <slot name="link">
                    <ChartLink :url="link" :color="color ?? 'success'" />
                </slot>
            </div>
        </div>
        <div class="chart-portlet-body kt-portlet__body kt-portlet__body--fluid">
            <div class="kt-widget20">
                <slot name="description" v-if="useDescription">
                    <div class="kt-widget20__content kt-portlet__space-x">
                        <span :class="['kt-widget20__number', customFontColorClass]">
                            &nbsp;<span :class="['kt-spinner', 'kt-spinner--md', `kt-spinner--${color}`]"></span>
                        </span>
                        <span class="kt-widget20__desc">{{ description }}</span>
                    </div>
                </slot>
                <div class="kt-widget20__chart" :style="chartContainerStyle">
                    <canvas class="plot" ref="canvas"></canvas>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, ref } from "vue";

    import ChartLink from "@/portal/components/dashboard/elements/ChartLink.vue";

    const props = withDefaults(
        defineProps<{
            portletId?: string;
            title: string;
            chartHeight?: string;
            color?: "success" | "primary" | "warning" | "danger";
            link?: string;
            buttonText?: string;
            useDescription?: boolean;
            description?: string;
            useCustomFontColor?: boolean;
        }>(),
        {
            chartHeight: "130px",
            useDescription: true,
            useCustomFontColor: true,
        }
    );

    const chartContainerStyle = computed(() => ({
        height: props.chartHeight,
    }));
    const customFontColorClass = computed(() => (props.useCustomFontColor ? `kt-font-${props.color}` : ""));

    const canvas = ref<HTMLCanvasElement | null>(null);

    defineExpose({ canvasElement: canvas });
</script>

<style lang="scss">
    .chart-portlet {
        .chart-portlet-body {
            padding-top: 0 !important;
        }
    }
</style>
